module.exports = __webpack_public_path__ + "img/no-apps-activity.133fa7b7.png";